export var defaultAttributesFn = function defaultAttributesFn(p) {
  return {};
};
export var createExtender = function createExtender(defaults) {
  var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.create(Object.prototype);

  if (!defaults) {
    throw new Error('a default set of overrides *must* be passed in as the first argument');
  }

  return function getOverrides(key) {
    var _defaults$key = defaults[key],
        defaultCssFn = _defaults$key.cssFn,
        defaultAttributesFn = _defaults$key.attributesFn,
        defaultComponent = _defaults$key.component;

    if (!overrides[key]) {
      return {
        cssFn: defaultCssFn,
        attributesFn: defaultAttributesFn,
        component: defaultComponent
      };
    }

    var _overrides$key = overrides[key],
        customCssFn = _overrides$key.cssFn,
        customAttributesFn = _overrides$key.attributesFn,
        customComponent = _overrides$key.component;

    var composedCssFn = function composedCssFn(state) {
      return customCssFn(defaultCssFn(state), state);
    };

    return {
      cssFn: customCssFn ? composedCssFn : defaultCssFn,
      attributesFn: customAttributesFn || defaultAttributesFn,
      component: customComponent || defaultComponent
    };
  };
};